<template>
  <div class="popup popup-cancelRule" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;"  id="cancelRule">
    <div class="shorexDetail-title js-returnShorexBtn">
      <p>{{isEditInvoice?'编辑':'新增'}}报销凭证抬头</p>
      <a class="shorexDetail-returnButton" @click="goBack()">
        <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png" alt="">
      </a>
    </div>
    <div class="ruleDetail" id="cancelRuleDetail">
      <div class="addInvoice-con" v-if="isShow">
        <div class="addInvoice-main">
          <div class="addInvoice-form">
            <div class="addInvoice-item" style="padding: 0 15px">
              <div class="addInvoice-item-title">类型<img @click="showTypeExplain"  src="https://resource.rcclchina.com.cn/invoice/question-icon.png" alt=""></div>
              <div class="addInvoice-item-content">
                <div class="invoice-tab" v-for="(i,idx) in invoiceTypeSelect" :key="idx"
                     :class="businessType == i.type ? 'active':''"
                     @click="changeInvoiceType(i.type)">
                  {{i.title}}
                </div>
              </div>
            </div>
            <div class="addInvoice-item">
              <div class="addInvoice-item-title">抬头</div>
              <div class="addInvoice-item-content">
                <input type="text" :placeholder="invoiceTypeInfo.title"
                       v-model="currentInvoiceFrom.customerName"
                       @input="inputCustomerName"
                       @compositionstart="businessListCompositionStart"
                       @compositionend="businessListCompositionEnd" maxlength="50">
                <img v-if="currentInvoiceFrom.customerName && currentInvoiceFrom.customerName.length>0"
                     @click="customerNameClear" class="clear" src="https://resource.rcclchina.com.cn/wechatMiniProgram/invoice/inputClear.png" alt="">
              </div>
            </div>
            <div class="companySelect" v-if="showBusinessList && businessList && businessList.length>0">
              <div class="companySelect-main">
                <div v-for="(x,idx) in businessList" :key="idx" class="companySelect-item" @click.prevent="selectBusiness(x)">
                  <div class="name" v-html="x.titleHtml"></div>
                  <div class="nsrsbh">税号：{{x.nsrsbh}}</div>
                </div>
              </div>
            </div>
            <div class="addInvoice-item" v-if="currentInvoiceFrom.businessType !==1">
              <div class="addInvoice-item-title">
                税号
                <img @click="showNsrsbhExplain" src="https://resource.rcclchina.com.cn/invoice/question-icon.png" alt="">
              </div>
              <div class="addInvoice-item-content">
                <input type="text" :placeholder="invoiceTypeInfo.nsrsbh" v-model="currentInvoiceFrom.nsrsbh" maxlength="20">
              </div>
            </div>
            <div v-if="businessType!==1">
              <div class="addInvoice-item">
                <div class="addInvoice-item-title">公司地址</div>
                <div class="addInvoice-item-content">
                  <input type="text" maxlength="100" placeholder="选填，若有则必须填写" v-model="currentInvoiceFrom.customerAddress">
                </div>
              </div>
              <div class="addInvoice-item">
                <div class="addInvoice-item-title">公司电话</div>
                <div class="addInvoice-item-content">
                  <input type="text" maxlength="50" placeholder="选填，若有则必须填写" v-model="currentInvoiceFrom.customerPhone">
                </div>
              </div>
              <div class="addInvoice-item">
                <div class="addInvoice-item-title">银行名称</div>
                <div class="addInvoice-item-content">
                  <input type="text" maxlength="100" placeholder="选填，若有则必须填写" v-model="currentInvoiceFrom.customerBankName">
                </div>
              </div>
              <div class="addInvoice-item">
                <div class="addInvoice-item-title">银行账号</div>
                <div class="addInvoice-item-content">
                  <input type="text" maxlength="50" placeholder="选填，若有则必须填写" v-model="currentInvoiceFrom.customerBankCard">
                </div>
              </div>
            </div>
            <div class="addInvoiceBtn">
              <div class="addInvoiceBtn-text" @click="saveInvoice">保存</div>
            </div>
          </div>
        </div>
        <div v-if="isShowInvoiceTips" class="invoice-info-tips">
          <div>{{invoiceErrorMsg}}</div>
        </div>
        <div class="form-tips">
          *以上信息仅用于开具发票
        </div>
      </div>
    </div>
    <BottomPopup :show="showInvoiceTypePopup"
                 title="发票类型说明"
                 @close="invoiceTypeClose">
      <div class="invoiceTypePopup" :style="businessType===1 ? 'left: 60px;top: 86px':''">
        <div class="nsrsbh-con">
          <div class="nsrsbh-type">企业</div>
          <div class="nsrsbh-con-item">
            <span class="tips-dot"></span>在境内注册的企业，必须填写税号。
          </div>
          <div class="nsrsbh-con-item">
            <span class="tips-dot"></span>若为境外注册企业，无税号，请在“个人”中填写。
          </div>
          <div class="nsrsbh-type" style="margin-top: 25px">非企业性单位</div>
          <div class="nsrsbh-con-item">
            <span class="tips-dot"></span>如有税号，请必须填写。
          </div>
        </div>
      </div>
    </BottomPopup>
    <BottomPopup :show="isShowNsrsbn"
                 title="纳税人识别号"
                 @close="invoiceNsrsbnClose">
      <div class="invoiceTypePopup" :style="businessType===1 ? 'left: 60px;top: 0':''">
        <div class="nsrsbh-con" v-if="businessType!==1">
          <div class="nsrsbh-con-item" style="margin-bottom: 20px;"><span class="tips-dot"></span>纳税人识别号是税务登记证上唯一识别企业的税号，由15-20位字符组成。</div>
          <div class="nsrsbh-con-item"><span class="tips-dot"></span>按照国税总局公告，自2017年7月1日起，企业索取的增值税普通发票需填写纳税人识别号，不符合规定的发票， 不得作为合法税收凭证。</div>
        </div>
        <div class="nsrsbh-con" v-else >
          <div class="nsrsbh-con-item">
            <span class="tips-dot"></span>
            按照国家税务总局政策规定，如需将发票归集至个人所得税APP个人票夹中展示，请提供姓名及身份证号（仅限大陆身份证）；如无需归集，可仅提供姓名。
          </div>
        </div>
      </div>
    </BottomPopup>
  </div>
</template>
<script>
import api from "@/api";
import BottomPopup from "@/components/Booking/BottomPopup.vue";
import {checkStr} from "@/utilities/tools";
export default {
  name: "invoiceFrom",
  components: {BottomPopup},
  props: {
    onGoBack: {
      type: Function
    },
    isShow: {
      type: Boolean,
      default () {
        return false
      }
    },
    currentInvoice:{
      type: Object,
      default () {
        return {}
      }
    },
    isEditInvoice:{
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data(){
    return {
      invoiceTypeInfo:{
        title : '必填，公司名称',
        nsrsbh : '必填，纳税人识别号'
      },  // 弹窗文案
      invoiceTypeSelect:[
        {title:'企业',type:2},
        {title:'非企业性单位',type:3},
        {title:'个人',type:1}
      ],
      businessType:2,
      isShowInvoiceType:false,
      showBusinessList:false,
      businessList:null,  // 公司列表
      isShowNsrsbn:false,
      isShowInvoiceTips:false,  // 显示发票未填写时提示
      invoiceErrorMsg:'请完整填写报销凭证抬头信息',
      currentInvoiceFrom:{
        businessType: 1,
        customerName: "",
        amount: null,
        nsrsbh: "",
        customerAddress: "",
        customerPhone: "",
        customerBankName: "",
        customerBankCard: "",
        verifyInfoMsg: "",
        showInvoiceAmountMsg: false,
        showInvoiceTitleMsg:false
      },
      showInvoiceTypePopup:false,
      allowBusinessSearch:true
    }
  },
  computed: {

  },
  methods: {
    goBack () {
      this.onGoBack()
    },
    // 切换类型
    changeInvoiceType(type){
      this.businessType = type
      this.currentInvoiceFrom.businessType = type
      if(type===1){
        this.showBusinessList = false
      }
    },
    showTypeExplain(){
      this.showInvoiceTypePopup = true
    },
    async inputCustomerName(event) {
      if(!this.allowBusinessSearch || this.businessType===1) return;
      // 清除之前的定时器
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }
      // 设置新的定时器
      this.debounceTimeout = setTimeout(() => {
        this.searchBusinessList(event);
      }, 300); // 300 毫秒后执行
    },
    async searchBusinessList(e) {
      // 获取用户输入并去除前后空白字符
      const keyword = e.target.value.trim();
      this.currentInvoiceFrom.customerName = keyword;
      // 如果去除空白后的输入为空，则不显示下拉列表且清空之前的查询结果
      if (!keyword) {
        this.businessList = [];
        this.showBusinessList = false;
      } else {
        let { data,success,errMsg } = await api.booking.getCompanyList({key: this.currentInvoiceFrom.customerName})
        if(success){
          this.businessList = this.formatBusinessRows(data, keyword);
          this.showBusinessList = true;
        }else{
          this.$alert.show(errMsg);
        }
      }
    },
    formatBusinessRows(rows, keyword) {
      let currList = [];
      rows && rows.forEach(item => {
        if(item.qymc.indexOf(keyword)>=0) {
          currList.push({
            ...item,
            titleHtml: item.qymc
          })
        }
      });
      return currList;
    },
    businessListCompositionStart() {
      this.allowBusinessSearch = false;
    },
    businessListCompositionEnd(e) {
      this.allowBusinessSearch = true;
      this.inputCustomerName(e);
    },
    selectBusiness(x){
      this.currentInvoiceFrom.businessType = this.businessType
      let companyInfo = {
        ...this.currentInvoice,
        customerName: x.qymc,
        nsrsbh: x.nsrsbh,
        customerAddress: x.dz,
        customerPhone: x.dh,
        customerBankName: x.yh,
        customerBankCard: x.zh,
      }
      this.currentInvoiceFrom = { ...companyInfo };
      this.showBusinessList = false;
    },
    showNsrsbhExplain(){
      this.showInvoiceTypePopup = false
      this.isShowNsrsbn = !this.isShowNsrsbn
    },
    saveInvoice(){
      this.currentInvoiceFrom = { ...this.currentInvoice,...this.currentInvoiceFrom }
      this.currentInvoiceFrom.businessType = this.businessType
      let index = this.currentInvoice.index;
      console.log('index',index,this.currentInvoice)
      let currentInvoice = this.currentInvoiceFrom;
      if(this.isShowInvoiceTips) return;
      if(currentInvoice.customerName === '') {
        this.invoiceErrorMsg = `请完整填写报销凭证抬头信息`;
        this.isShowInvoiceTips = true
        setTimeout(()=>{
          this.isShowInvoiceTips = false
        },1500)
        return
      }
      if(currentInvoice.businessType === 2) {
        if(currentInvoice.nsrsbh === ''){
          this.invoiceErrorMsg = `请完整填写报销凭证抬头信息`;
          this.isShowInvoiceTips = true
          setTimeout(()=>{
            this.isShowInvoiceTips = false
          },1500)
          return;
        }else{
          if(!/^[0-9a-zA-Z]{15,20}$/.test(currentInvoice.nsrsbh)){
            this.invoiceErrorMsg = `请填写正确的税号`;
            this.isShowInvoiceTips = true
            setTimeout(()=>{
              this.isShowInvoiceTips = false
            },1500)
            return;
          }
        }
      }else{
        if(currentInvoice.nsrsbh !== '' && !/^[0-9a-zA-Z]{15,20}$/.test(currentInvoice.nsrsbh)){
          this.invoiceErrorMsg = `请填写正确的税号`;
          this.isShowInvoiceTips = true
          setTimeout(()=>{
            this.isShowInvoiceTips = false
          },1500)
          return
        }
      }
      if(currentInvoice.customerPhone !== '' && !checkStr(currentInvoice.customerPhone.trim(),'telephone')) {
        this.invoiceErrorMsg = `请填写正确的公司电话`;
        this.isShowInvoiceTips = true
        setTimeout(()=>{
          this.isShowInvoiceTips = false
        },1500)
        return;
      }
      if(currentInvoice.businessType===1){
        currentInvoice.customerAddress = "";
        currentInvoice.customerPhone = "";
        currentInvoice.customerBankName = "";
        currentInvoice.customerBankCard = "";
      }
      this.$emit('saveInvoice',currentInvoice,index)
    },
    invoiceTypeClose(){
      this.showInvoiceTypePopup = false
    },
    invoiceNsrsbnClose(){
      this.isShowNsrsbn = false
    },
    customerNameClear(){
      this.currentInvoiceFrom.customerName = ""
      this.businessList = []
      this.showBusinessList = false
    }
  },
  watch: {
    'currentInvoice.businessType'(val) {
      this.businessType = val
    },
    'businessType'(val) {
      if(val){
        this.currentInvoiceFrom.businessType = val
        if(val===1){
          this.invoiceTypeInfo.title = '必填，个人姓名'
          this.invoiceTypeInfo.nsrsbh = '必填，身份证号'
          this.currentInvoiceFrom.nsrsbh = ''
        }else if(val===2){
          this.invoiceTypeInfo.title = '必填，公司名称'
          this.invoiceTypeInfo.nsrsbh = '必填，纳税人识别号'
        }else{
          this.invoiceTypeInfo.title = '必填，单位名称'
          this.invoiceTypeInfo.nsrsbh = '如有税号，请务必填写'
        }
      }
    },
    'isShow'(val){
      if(val){
        this.currentInvoiceFrom = { ...this.currentInvoice }
      }
    }
  },
}
</script>
<style scoped lang="less">
.popup {
  position: fixed;
  background-color: #f6f6f6;
}
#cancelRule.modal-out {
  transform: translate3d(100%, 0, 0);
}
.shorexDetail-title {
  padding: 0px 20px;
  background-color: #fff;
  overflow: hidden;
  text-align: center;
  margin-bottom: 10px;
  height: 50px;
  > p {
    font-family: PingFang-SC-Medium;
    font-size: 14px;
    color: #333333;
    letter-spacing: 1px;
    text-align: center;
    margin: 0;
    line-height: 50px;
  }
  .shorexDetail-returnButton {
    width: 30px;
    position: absolute;
    top: 15px;
    left: 20px;
    text-align: left;
  }
  img {
    width: 33%;
  }
}

.addInvoice-con{
  width: 100%;
  margin-top: 10px;
  .addInvoice-main{
    width:100%;
    background: #fff;
    .addInvoice-title{
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      padding: 0;
      border-bottom: 1px solid #d9d9d9;
      position: relative;
      .popup-close{
        width: 25px;
        height: 25px;
        position: absolute;
        padding: 5px;
        right: 14px;
        top: 14px;
        cursor: pointer;
      }
    }
    .addInvoice-form{
      //padding: 0 15px;
      .addInvoice-item{
        display: flex;
        align-items: center;
        padding: 8px 15px;
        position: relative;
        .addInvoice-item-title{
          min-width: 73px;
          font-size: 14px;
          color: #202020;
          text-align: left;
          position: relative;
          display: flex;
          align-items: center;
          img{
            width: 17px;
            height: 17px;
            margin-left: 5px;
            cursor: pointer;
          }
        }
        .addInvoice-item-content{
          width: 100%;
          display: flex;
          align-items: center;
          position: relative;
          gap: 38px;
          font-size: 14px;
          color: #282828;
          .invoice-tab{
            padding: 11px 0;
          }
          .invoice-tab.active{
            border-bottom: 2px solid #F8C533;
          }
          input[type="text"],input[type="number"]{
            width: 100%;
            height: 31px;
            font-style: normal;
            font-size: 13px;
            border: none;
            padding-right: 15px;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #282828;
          }
          ::-webkit-input-placeholder{
            color: #CFCFCF;
          }
          .clear{
            width: 14px;
            height: 14px;
          }
        }
      }
      .companySelect{
        width:100%;
        background-color: #F6F6F6;
        box-sizing: border-box;
        height: 100px;
        overflow: auto;
        .companySelect-main{
          width: 100%;
          overflow-y: auto;
          box-sizing: border-box;
          .companySelect-item{
            cursor: pointer;
            border-bottom: 1px solid #EEEEEE;
            padding: 4px 0 4px 89px;
            .name{
              font-size: 12px;
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              color: #282828;
            }
            .nsrsbh{
              font-size: 9px;
              color: #939393;
            }
          }
        }
      }
      .receiveInfo-tips{
        height: 20px;
        .noFilled{
          display: flex;
          align-items: center;
          gap: 5px;
          color: #fe0000;
          justify-content: center;
          img{
            display: block;
            width: 14px;
            height: 14px  ;
          }
        }
      }
      .addInvoiceBtn{
        width: 100%;
        height: 74px;
        font-size: 14px;
        font-weight: bold;
        line-height: 50px;
        color: #fff;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 0;
        .addInvoiceBtn-text{
          width: 345px;
          height: 39px;
          background: linear-gradient( 225deg, #00AEEA 0%, #006AB6 100%);
          border-radius: 4px;
          line-height: 39px;
          text-align: center;
        }
      }
    }
  }
  .form-tips{
    font-size: 12px;
    color: #999999;
    width: 100%;
    padding: 13px 0 0 16px;
  }
  .invoice-info-tips{
    width: 218px;
    height: 46px;
    background-color: rgba(32,32,32,0.7);
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    position: absolute;
    border-radius: 6px;
    line-height: 46px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }
}
.addInvoice-item{
  padding: 11px 0;
  border-bottom: 1px solid #EDEDED;
}
//.addInvoice-item:first-child{
//  padding: 0;
//}
.addInvoice-item:last-child{
  border-bottom: none;
}
.invoiceTypePopup{
  width: 100%;
  color: #282828;
  font-size: 14px;
  border-radius: 20px;
  padding: 14px 15px 54px;
  z-index: 9;
  .nsrsbh-con{
    .nsrsbh-type{
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 13px;
    }
    .nsrsbh-con-item{
      position: relative;
      padding-left: 10px;
    }
  }
  .tips-dot{
    position: absolute;
    top: 13px;
    left: 0;
    transform: translate(-50%,-50%);
    display: block;
    width: 3px;
    height: 3px;
    background: #282828;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>